import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Remet la page en haut à chaque changement de page.
 *
 * React Router ne le fait pas : sans ce composant, « Voir la fiche complète »
 * cliqué depuis le bas de la boutique ouvrait la fiche produit… en bas, et il
 * fallait remonter toute la page à la main.
 *
 * Trois cas :
 *  - navigation normale (lien, bouton)  -> haut de page, sans animation : un
 *    défilement animé sur une page de 14 000 px ressemble à une fusée et
 *    retarde l'affichage du contenu ;
 *  - lien avec ancre (/#reviews)        -> on va à l'ancre ; la section peut
 *    n'exister qu'après le rendu, d'où les deux essais différés ;
 *  - bouton Précédent / Suivant (POP)   -> on ne touche à rien : on s'attend à
 *    retrouver l'endroit qu'on avait quitté, pas le haut de la page.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const typeNavigation = useNavigationType();

  useEffect(() => {
    if (typeNavigation === 'POP') return undefined;

    if (hash) {
      const versAncre = () => {
        const cible = document.getElementById(hash.slice(1));
        if (cible) cible.scrollIntoView({ block: 'start' });
        return Boolean(cible);
      };
      if (versAncre()) return undefined;
      const trame = requestAnimationFrame(versAncre);
      const tardif = setTimeout(versAncre, 200);
      return () => {
        cancelAnimationFrame(trame);
        clearTimeout(tardif);
      };
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    return undefined;
  }, [pathname, hash, typeNavigation]);

  return null;
}
